import { render, staticRenderFns } from "./QualityDataList.vue?vue&type=template&id=7634a58a&"
import script from "./QualityDataList.vue?vue&type=script&lang=js&"
export * from "./QualityDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports